import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      // メニューが開いたときにbodyのスクロールを無効化
      document.body.style.overflow = 'hidden';
    } else {
      // メニューが閉じたときにbodyのスクロールを有効化
      document.body.style.overflow = '';
    }

    // クリーンアップ関数
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    // フォーカスを外す
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const menuItems = [
    { label: 'ホーム', path: '/2025' },
    { label: 'メッセージ', path: '/2025/message' },
    { label: 'マップ/売店', path: '/2025/map' },
    { label: 'タイムテーブル', path: '/2025/timetable' },
    { label: 'イベント一覧', path: '/2025/events' },
    { label: 'アクセス', path: '/2025/access' },
    { label: 'お知らせ', path: '/2025/news' },
    { label: '実行委員会ブログ', path: '/2025/blog' },
  ];

  return (
    <>
      <header className={styles.header}>
        <div className={styles.header__container}>
          <h1>
            <Link to="/2025" className={styles.header__logo}>
              <img src="/images/2025/logo.png" alt="かまた祭 2025" width={102} height={53} />
            </Link>
          </h1>
          <button
            className={styles.menu__open}
            onClick={toggleMenu}
            aria-label="メニューを開く"
            aria-expanded={isMenuOpen}
          >
            <span className={styles['menu__open-text']}>menu</span>
          </button>
        </div>
      </header>

      <div className={`${styles.menu} ${isMenuOpen ? styles['menu--open'] : ''}`}>
        <div className={styles.menu__overlay} onClick={closeMenu}></div>
        <div className={styles.menu__content}>
          <button className={styles.menu__close} onClick={closeMenu} aria-label="メニューを閉じる">
            <span className={styles['menu__close-text']}>close</span>
          </button>

          <p className={styles.menu__title}>MENU</p>

          <div className={styles.menu__scrollable}>
            <nav className={styles.menu__nav}>
              <ul className={styles.menu__list}>
                {menuItems.map((item) => (
                  <li key={item.path} className={styles.menu__item}>
                    <Link to={item.path} className={styles.menu__link} onClick={closeMenu}>
                      <span className={styles['menu__link-text']}>{item.label}</span>
                      <svg
                        width="20"
                        height="12"
                        viewBox="0 0 13 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0.559082 4.00781H12.0291" stroke="black" strokeLinecap="round" />
                        <path
                          d="M8.32422 0.707031L12.4419 4.00115"
                          stroke="black"
                          strokeLinecap="round"
                        />
                        <path
                          d="M8.32422 7.30193L12.4419 4.00781"
                          stroke="black"
                          strokeLinecap="round"
                        />
                      </svg>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div className={styles.menu__social}>
              <a
                href="https://www.instagram.com/act__neec/?igsh=MTR6eGg5cDg0N2hnNw%3D%3D#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles['menu__social-link']}
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="27"
                  viewBox="0 0 26 27"
                  fill="none"
                >
                  <path
                    d="M7.58438 0.0913131C6.20691 0.157541 5.26598 0.382347 4.4439 0.710585C3.59282 1.04859 2.87146 1.50189 2.15373 2.23621C1.43522 2.97105 0.994012 3.70747 0.664661 4.57556C0.345927 5.41542 0.129726 6.3748 0.0691385 7.77931C0.00855048 9.18672 -0.00517244 9.63554 0.00155956 13.2182C0.00829156 16.8003 0.0238269 17.2499 0.0895934 18.6576C0.15536 20.0611 0.375186 21.0194 0.697286 21.8577C1.02948 22.725 1.4738 23.4598 2.19464 24.1915C2.91522 24.9231 3.63839 25.3725 4.49077 25.7084C5.31414 26.0329 6.25585 26.2538 7.63383 26.3153C9.01467 26.3773 9.45562 26.391 12.9702 26.3841C16.4864 26.3773 16.9274 26.3614 18.3082 26.2947C19.6857 26.2276 20.6256 26.0028 21.4487 25.6754C22.2998 25.3361 23.0211 24.8841 23.7388 24.1495C24.4566 23.4152 24.8978 22.6782 25.2271 21.8096C25.5459 20.9706 25.7628 20.0109 25.8227 18.6075C25.883 17.1995 25.8972 16.7496 25.8905 13.1678C25.8838 9.58541 25.868 9.13659 25.8025 7.7297C25.737 6.32519 25.5164 5.36713 25.1948 4.52859C24.8621 3.6613 24.4183 2.92698 23.6977 2.19478C22.9771 1.46337 22.2539 1.01296 21.4015 0.678131C20.5777 0.353323 19.6365 0.131947 18.2585 0.07126C16.8779 0.00846208 16.4372 -0.00525847 12.9213 0.0016018C9.40616 0.00846208 8.96548 0.0237658 7.58464 0.0913131M7.73559 23.9408C6.47334 23.8849 5.78797 23.6711 5.33123 23.492C4.72639 23.2535 4.29476 22.9674 3.84035 22.5081C3.38698 22.0468 3.10553 21.6083 2.86939 20.9933C2.69203 20.5278 2.47842 19.8302 2.41938 18.5439C2.35517 17.1534 2.34041 16.7362 2.3342 13.2134C2.32747 9.69174 2.34015 9.27432 2.3997 7.88274C2.45382 6.59749 2.66484 5.89801 2.84013 5.43309C3.0742 4.81593 3.35384 4.37688 3.80566 3.91381C4.25825 3.451 4.68858 3.16498 5.29265 2.92434C5.74913 2.74255 6.43347 2.52671 7.6952 2.46576C9.0605 2.3998 9.4696 2.38581 12.9254 2.37895C16.3821 2.37209 16.7917 2.38449 18.1572 2.44571C19.4185 2.50165 20.1049 2.71458 20.5608 2.89453C21.1662 3.13305 21.5978 3.41723 22.0517 3.87845C22.5056 4.33967 22.787 4.77741 23.0232 5.39431C23.2013 5.85817 23.4134 6.5566 23.4729 7.84184C23.5379 9.23316 23.5527 9.65032 23.5589 13.1723C23.5656 16.695 23.5529 17.1122 23.4931 18.503C23.4382 19.7893 23.2288 20.488 23.0527 20.9539C22.8186 21.5698 22.5387 22.0096 22.0867 22.4727C21.6346 22.9339 21.2042 23.2215 20.5997 23.4622C20.1442 23.6434 19.4588 23.8598 18.1979 23.9208C16.8326 23.9862 16.4235 24.0012 12.9664 24.0076C9.51051 24.0144 9.10141 24.0012 7.73585 23.9408M18.2893 6.14076C18.2908 7.01439 18.9881 7.72179 19.8454 7.7202C20.7032 7.71862 21.3974 7.00858 21.3961 6.13469C21.3943 5.26106 20.6973 4.55313 19.8395 4.55471C18.9817 4.5563 18.2875 5.26686 18.289 6.14049M6.29883 13.2058C6.30582 16.9473 9.28783 19.9737 12.9586 19.9663C16.6296 19.9589 19.601 16.9212 19.594 13.1797C19.5868 9.4395 16.6045 6.41148 12.933 6.4186C9.2622 6.42599 6.29158 9.46509 6.29883 13.2058ZM8.63069 13.201C8.62654 10.7728 10.5553 8.79991 12.9376 8.79569C15.3205 8.79094 17.2567 10.7556 17.2614 13.1844C17.266 15.6132 15.3373 17.5855 12.9539 17.5903C10.5713 17.595 8.63509 15.6301 8.63069 13.2013"
                    fill="#063986"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div className={styles.menu__decorations}>
            <span className={styles['menu__decoration--star1']}></span>
            <span className={styles['menu__decoration--star2']}></span>
            <span className={styles['menu__decoration--star3']}></span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
